import { render, staticRenderFns } from "./SalesChart.vue?vue&type=template&id=58ae1350&"
import script from "./SalesChart.vue?vue&type=script&lang=js&"
export * from "./SalesChart.vue?vue&type=script&lang=js&"
import style0 from "./SalesChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports